import { render, staticRenderFns } from "./PartnerProductAccountDetail.vue?vue&type=template&id=64f451fe&scoped=true&"
import script from "./PartnerProductAccountDetail.vue?vue&type=script&lang=js&"
export * from "./PartnerProductAccountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f451fe",
  null
  
)

export default component.exports